import {Form} from "react-bootstrap";
import React from "react";
import {MM_QUESTION} from "../../scripts/myga-model";
import {validateCondition} from "../../scripts/validation";

export default function QuestionTextField(props) {
  const {question, data, handleChange, pattern, responseClass,
    required, inputMode, handleKeyDown, handleOnBlur, handleBeforeInput} = props;
  const disabled = !validateCondition(question.enableCondition,data);
  const value = props.value ? props.value : data[question.key] ? data[question.key] : '';

  return (
    <Form.Control className={`page-input ${responseClass}`}
                  type="text"
                  id={question.key}
                  name={question.key}
                  disabled={disabled}
                  required={required}
                  pattern={pattern}
                  inputMode={inputMode}
                  value={value}
                  onChange={handleChange(question.key)}
                  onKeyDown={handleKeyDown}
                  onBlur={handleOnBlur}
                  onBeforeInput={handleBeforeInput}
                  placeholder={question[MM_QUESTION.placeholder]}/>
  )
}